// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_94005a', '__Inter_Fallback_94005a'","fontStyle":"normal"},"className":"__className_94005a","variable":"__variable_94005a"};